import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
export var IFrameService = /*#__PURE__*/ function() {
    "use strict";
    function IFrameService() {
        _class_call_check(this, IFrameService);
    }
    var _proto = IFrameService.prototype;
    /**
   * Handle IFrame
   */ _proto.handleIFrame = function handleIFrame(iFrameDetail) {
        this.customIFrameEvent = new CustomEvent("iframeServiceNotificationEvent", {
            detail: iFrameDetail
        });
        document.dispatchEvent(this.customIFrameEvent);
    };
    return IFrameService;
}();
